import type { Lang, OfferStatus, SizeKey } from '@shared/types';
import type { TFunction } from './i18n';

const NBSP = ' ';

export function formatAmount(value: number): string {
  return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
}

export function formatPrice(amount: number, isFrom: boolean, lang: Lang = 'cs'): string {
  const prefix = isFrom ? (lang === 'cs' ? 'od ' : 'from ') : '';
  return `${prefix}${formatAmount(amount)}${NBSP}AED`;
}

// Popisky stavů, velikostí a kategorií jsou ve slovníku (`lib/i18n.tsx`) pod klíči
// `status.*`, `size.*`, `category.*`. Tady zůstává jen pořadí a pomocníci.

export const STATUS_KEYS: OfferStatus[] = ['draft', 'sent', 'accepted', 'archived'];

export const statusLabel = (t: TFunction, s: OfferStatus) => t(`status.${s}`);
export const sizeLabel = (t: TFunction, s: SizeKey) => t(`size.${s}`);

export const CATEGORY_KEYS = ['ownership', 'visa', 'banking', 'legal', 'resale', 'other'] as const;

export function categoryLabel(t: TFunction, category: string): string {
  return (CATEGORY_KEYS as readonly string[]).includes(category)
    ? t(`category.${category as (typeof CATEGORY_KEYS)[number]}`)
    : category;
}

export const STATUS_CLASSES: Record<OfferStatus, string> = {
  draft: 'bg-gray-100 text-gray-600',
  sent: 'bg-teal-light text-teal',
  accepted: 'bg-positive-bg text-positive',
  archived: 'bg-gray-100 text-gray-400',
};

export function formatDate(iso: string, lang: Lang = 'cs'): string {
  const [y, m, d] = iso.split('-');
  if (!y || !m || !d) return iso;
  return lang === 'cs' ? `${Number(d)}. ${Number(m)}. ${y}` : `${Number(d)}/${Number(m)}/${y}`;
}
